import React from "react";
import MultiCarousel from "../components/carousel/MultiCarousel";
import Brands from "../components/Brands";
import MessageAccueil from "../components/MessageAccueil";

const Accueil = ({ website }) => {
    return (
        <div>
            <MessageAccueil website={website}></MessageAccueil>
            <MultiCarousel></MultiCarousel>
            <Brands></Brands>
        </div>
    );
};

export default Accueil;
